import { creators } from '@/mocks/data';

export default function CreatorShowcase() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">达人推荐</h2>
          <p className="text-sm text-foreground-500 mt-3">发现优秀创作者，关注你喜欢的达人</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {creators.map((creator) => (
            <div key={creator.name} className="bg-background-50 rounded-xl p-5 text-center border border-background-200/70 hover:border-background-300/60 transition-all cursor-pointer group">
              <div className="relative w-20 h-20 mx-auto mb-4">
                <img src={creator.avatar} alt={creator.name} className="w-full h-full rounded-full object-cover" loading="lazy" />
                {creator.verified && (
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 flex items-center justify-center bg-accent-500 rounded-full">
                    <i className="ri-verified-badge-fill text-background-50 text-xs"></i>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 font-heading">{creator.name}</h3>
              <p className="text-xs text-foreground-500 mb-3">{creator.description}</p>
              <div className="flex items-center justify-center gap-4 text-xs text-foreground-400">
                <span>{creator.followers >= 10000 ? `${(creator.followers / 10000).toFixed(0)}万` : creator.followers} 粉丝</span>
                <span>{creator.videos} 视频</span>
              </div>
              <button className="mt-4 w-full py-2 text-xs font-medium whitespace-nowrap cursor-pointer rounded-full bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                + 关注
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}